import Vue from 'vue'

const LOCALE_KEY = 'hrws_locale'

const messages = {
  'zh-CN': {
    titles: {
      default: '湖州互荣万顺特材科技有限公司',
      home: '首页 - 湖州互荣万顺特材科技有限公司',
      about: '关于互荣万顺 - 湖州互荣万顺特材科技有限公司',
      products: '产品中心 - 湖州互荣万顺特材科技有限公司',
      productItem: '产品详情 - 湖州互荣万顺特材科技有限公司',
      applications: '应用领域 - 湖州互荣万顺特材科技有限公司',
      quality: '质量保障 - 湖州互荣万顺特材科技有限公司',
      news: '行业资讯 - 湖州互荣万顺特材科技有限公司',
      contact: '联系我们 - 湖州互荣万顺特材科技有限公司',
      privacy: '隐私与免责声明 - 湖州互荣万顺特材科技有限公司'
    },
    common: {
      menu: '菜单',
      langZh: '中文',
      langEn: 'EN'
    },
    nav: {
      home: '首页',
      about: '关于互荣万顺',
      products: '产品中心',
      applications: '应用领域',
      quality: '质量保障',
      news: '行业资讯',
      contact: '联系我们'
    },
    footer: {
      company: '湖州互荣万顺特材科技有限公司',
      rights: 'hzhrws.com 版权所有 · 业务方向：BA不锈钢无缝管 / EP不锈钢管道 / 不锈钢无缝方矩管',
      privacy: '隐私与免责声明'
    }
  },
  'en-US': {
    titles: {
      default: 'Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      home: 'Home - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      about: 'About HRWS - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      products: 'Products - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      productItem: 'Product Details - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      applications: 'Applications - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      quality: 'Quality Assurance - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      news: 'Industry Insights - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      contact: 'Contact Us - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      privacy: 'Privacy & Disclaimer - Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.'
    },
    common: {
      menu: 'Menu',
      langZh: '中文',
      langEn: 'EN'
    },
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      applications: 'Applications',
      quality: 'Quality',
      news: 'Insights',
      contact: 'Contact'
    },
    footer: {
      company: 'Huzhou Hurong Wanshun Special Materials Technology Co., Ltd.',
      rights: 'All rights reserved by hzhrws.com · BA seamless stainless tubing / EP electropolished stainless tubing / seamless square & rectangular stainless tubing',
      privacy: 'Privacy & Disclaimer'
    }
  }
}

const localeState = Vue.observable({
  locale: localStorage.getItem(LOCALE_KEY) || 'zh-CN'
})

function applyLocaleToDom(locale) {
  const lang = locale === 'en-US' ? 'en' : 'zh-CN'
  document.documentElement.lang = lang
  if (document.body) {
    document.body.classList.remove('lang-en', 'lang-zh')
    document.body.classList.add(locale === 'en-US' ? 'lang-en' : 'lang-zh')
  }
}

if (typeof document !== 'undefined') {
  applyLocaleToDom(localeState.locale)
}

function getByPath(obj, path) {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)
}

export function getLocale() {
  return localeState.locale
}

export function t(key) {
  const primary = getByPath(messages[localeState.locale], key)
  if (primary !== undefined) return primary
  const fallback = getByPath(messages['zh-CN'], key)
  return fallback !== undefined ? fallback : key
}

export function setLocale(locale) {
  if (!messages[locale]) return
  localeState.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)
  applyLocaleToDom(locale)
  // Trigger a lightweight reflow for components that depend on content width/height.
  window.dispatchEvent(new Event('resize'))
  window.dispatchEvent(new Event('localechange'))
}

export default {
  messages,
  localeState,
  getLocale,
  setLocale,
  t
}
